import React from 'react';
import { Dropdown, Input, Label } from 'semantic-ui-react';
import {
  ParamsName,
  ParamsBlock,
  ParamsContent,
  ParamsColumn,
  ParamsTagsBlock,
  ParamsTagsName,
  ParamsTagsColumn,
  InfoBlock,
  TimeLabel,
} from '../userPageStyles';
import { default_activity, default_gender, default_country } from '../../youslim2.0_Constants';
import ClientTagsBlock from '../../TagsBlock/ClientTagsBlock';
import { toastSuccess } from '../../../../utils/toastMessage';

const genderOptions = [
  {
    key: 1,
    text: 'Женский',
    value: 'Женский',
  },
  {
    key: 2,
    text: 'Мужской',
    value: 'Мужской',
  },
];

export const countryOptions = [
  { id: 44, key: 44, text: 'США', value: 'США' },
  { id: 45, key: 45, text: 'Европа', value: 'Европа' },
  { id: 63, key: 63, text: 'Израиль', value: 'Израиль' },
  { id: 64, key: 64, text: 'Украина', value: 'Украина' },
];

const activityOptions = [
  { key: 1, text: 'Низкая или отсутствует', value: 'Низкая или отсутствует', coefficient: 1.2 },
  {
    key: 2,
    text: 'Невысокая активность (1-3 тренировки в неделю)',
    value: 'Невысокая активность (1-3 тренировки в неделю)',
    coefficient: 1.375,
  },
  {
    key: 3,
    text: 'Умеренная активность (4-5 тренировок в неделю)',
    value: 'Умеренная активность (4-5 тренировок в неделю)',
    coefficient: 1.55,
  },
  {
    key: 4,
    text: 'Высокая активность (6-7 тренировок в неделю)',
    value: 'Высокая активность (6-7 тренировок в неделю)',
    coefficient: 1.725,
  },
  {
    key: 5,
    text: 'Экстремально высокая активность (2 и более тренировок в день)',
    value: 'Экстремально высокая активность (2 и более тренировок в день)',
    coefficient: 1.9,
  },
];

const UserParamsBlock = React.memo(
  ({
    allProductsTags,
    choosedTags,
    setChoosedTags,
    params,
    currentGender,
    setCurrentGender,
    currentCountry,
    setCurrentCountry,
    currentTimezone,
    setCurrentTimezone,
    deepLink,
    setDeepLink,
    currentActivity,
    setCurrentActivity,
    currentHeight,
    setCurrentHeight,
    currentWeight,
    setCurrentWeight,
    currentAge,
    setCurrentAge,
    currentTargetWeight,
    setCurrentTargetWeight,
  }) => {
    return (
      <ParamsContent>
        <ParamsColumn>
          <ParamsBlock>
            <ParamsName>Пол</ParamsName>
            <Dropdown
              placeholder="Выберите пол"
              fluid
              selection
              options={genderOptions}
              defaultValue={default_gender[params.sex_id - 1]}
              value={currentGender}
              onChange={(e, data) => setCurrentGender(data.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Рост</ParamsName>
            <Input
              style={{ width: '100%' }}
              type="number"
              placeholder="Введите рос..."
              defaultValue={params.height}
              value={currentHeight}
              onChange={(e) => setCurrentHeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Текущий вес</ParamsName>
            <Input
              style={{ width: '100%' }}
              // className="product-name-input"
              type="number"
              placeholder="Введите вес..."
              defaultValue={params.weight}
              value={currentWeight}
              onChange={(e) => setCurrentWeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Целевой вес</ParamsName>
            <Input
              style={{ width: '100%' }}
              type="number"
              placeholder="Введите целевой вес..."
              defaultValue={params.weight_target}
              value={currentTargetWeight}
              onChange={(e) => setCurrentTargetWeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Возраст</ParamsName>
            <Input
              style={{ width: '100%' }}
              type="number"
              placeholder="Введите возраст..."
              defaultValue={params.age}
              value={currentAge}
              onChange={(e) => setCurrentAge(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Активность</ParamsName>
            <Dropdown
              placeholder="Выберите активность"
              defaultValue={default_activity[params.activity_id - 1]}
              fluid
              selection
              options={activityOptions}
              value={currentActivity}
              onChange={(e, data) => setCurrentActivity(data.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Часовая зона</ParamsName>
            <Input
              disabled
              placeholder="зона"
              style={{ width: '100%' }}
              options={currentTimezone}
              value={currentTimezone}
              onChange={(e) => setCurrentTimezone(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Страна</ParamsName>
            <Dropdown
              placeholder="Выберите страну"
              fluid
              selection
              options={countryOptions}
              value={currentCountry}
              onChange={(e, data) => setCurrentCountry(data.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Ссылка</ParamsName>
            <Input
              type="text"
              disabled
              placeholder="ссылка"
              style={{ width: '100%' }}
              options={deepLink}
              value={deepLink !== null ? deepLink : ''}
              // value={deepLink}
              action={{
                color: 'teal',
                icon: 'copy',
                onClick: () =>
                  navigator.clipboard.writeText(
                    deepLink !== null ? toastSuccess('Ссылка скопирована') || deepLink : '',
                  ),
                // onClick: () => navigator.clipboard.writeText(deepLink !== null ? deepLink : ''),
              }}
              // onChange={(e) => setDeepLink(e.target.value)}
            />
          </ParamsBlock>

          <InfoBlock>*для создания пользователя все поля обязательные для заполнения</InfoBlock>
        </ParamsColumn>
        <ParamsTagsColumn>
          <ParamsTagsBlock>
            <ParamsTagsName>Теги запрещённых продуктов</ParamsTagsName>

            <ClientTagsBlock
              allTags={allProductsTags}
              choosedTags={choosedTags}
              setChoosedTags={setChoosedTags}
              height="270px"
              flexBasis="7%"
              width="100%"
            />
          </ParamsTagsBlock>
        </ParamsTagsColumn>
      </ParamsContent>
    );
  },
);

export default UserParamsBlock;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/UserParamsBlock/index.jsx